import apiClient from './apiClient';

const TEST_SESSIONS_PATH = '/test-sessions';

export const saveTestSession = async (sessionData) => {
    try {
        const response = await apiClient.post(`${TEST_SESSIONS_PATH}/save`, sessionData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error('Failed to save test session. Please try again.');
    }
};

export const getTestSessions = async () => {
    try {
        const response = await apiClient.get(TEST_SESSIONS_PATH);
        return response.data.data; // Return the list from ApiResponse
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error('Failed to load test sessions. Please try again.');
    }
};

export const recordAiResults = async (results) => {
    try {
        const response = await apiClient.post(`${TEST_SESSIONS_PATH}/record-results`, { results });
        return response.data;
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error('Failed to record AI results. Please try again.');
    }
};

export const getActiveSession = async (subjectId) => {
    try {
        const response = await apiClient.get(`${TEST_SESSIONS_PATH}/subject/${subjectId}/active`);
        // Returns null in .data if no active session
        return response.data.data || null;
    } catch (error) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error('Failed to load active session. Please try again.');
    }
};

